/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getLinkedAccounts} from '../api'

 export const useQueryGetLinkedAccounts = createReactQueryHook('getLinkedAccounts', getLinkedAccounts)
